import React from 'react'

function CompleteStep({ formData, additionalFields = [] }) {
    return (
        <div className="animate-fade-in">
            <div className="text-center py-10">
                <div className="mb-6">
                    <span className="svg-icon svg-icon-10x svg-icon-success">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"></circle>
                            <path d="M8 12L11 15L16 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                    </span>
                </div>
                <h3 className="fw-bold text-gray-900 mb-2">Ready to Launch Campaign</h3>
                <p className="text-muted mb-8">Review your campaign details before processing.</p>
                
                <div className="card bg-light-success border-0 mb-8">
                    <div className="card-body">
                        <div className="d-flex justify-content-between mb-4">
                            <span className="fw-semibold text-muted">Campaign Name:</span>
                            <span className="fw-bold">{formData.campaignName || 'Not set'}</span>
                        </div>
                        {additionalFields.map((field, index) => (
                            <div key={index} className="d-flex justify-content-between mb-4">
                                <span className="fw-semibold text-muted">{field.label}:</span>
                                <span className="fw-bold">{field.value || 'Not set'}</span>
                            </div>
                        ))}
                        <div className="d-flex justify-content-between">
                            <span className="fw-semibold text-muted">Selected Patients:</span>
                            <span className="fw-bold">{formData.selectedPatients.length}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CompleteStep
